import {
    IDatiqMenu,
    IDatiqMenuItem
} from './datiq-menu.interface';
import {
    DATIQ_DEFAULT_EMPTY_LABEL,
    DATIQ_DEFAULT_ID,
} from '@dat/datiq-core/models';
import { DatiqMenuType } from './datiq-menu.enums';

const DEFAULT_DATIQ_MENU_ICON = 'app:more';

export const emptyDatiqMenuItem: IDatiqMenuItem = {
    label: DATIQ_DEFAULT_EMPTY_LABEL,
    id: DATIQ_DEFAULT_ID(),
};

export const emptyDatiqMenu: IDatiqMenu = {
    id: DATIQ_DEFAULT_ID(),
    items: [],
    icon: DEFAULT_DATIQ_MENU_ICON,
    type: DatiqMenuType.Icon,
};
